import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import listMixin from '../listMixin';
import dataSourcesDataMixin from './dataSourcesDataMixin';
import { userItemsPerListMixin } from '@/utils/vuex';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicOriginatorsList',
  mixins: [listMixin, dataSourcesDataMixin, userItemsPerListMixin],
  props: {},
  data: function () {
    return {
      tableOptions: {
        ...defaultTableOptions
      },
      disableFetchOnCreatedMixin: true
    };
  },
  computed: {
    tableLocalizations() {
      let headers = [{
        text: this.$i18n_t('NiotaClassic.Common.table.id'),
        value: 'id',
        align: 'right'
      }, {
        text: this.$i18n_t('NiotaClassic.Originators.table.type'),
        value: 'type',
        align: 'start'
      }, {
        sortable: false
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.title'),
        value: 'title',
        align: 'start'
      }, {
        text: this.$i18n_t('NiotaClassic.Originators.table.status'),
        value: 'status',
        align: 'center',
        sortable: false
      }, {
        sortable: false
      }, {
        text: this.$i18n_t('NiotaClassic.Originators.table.datasource'),
        value: 'datasource',
        align: 'start',
        sortable: true
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
        value: 'createdAt'
      }, {
        sortable: false
      }];
      return {
        headers,
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  },
  created() {
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  methods: {
    updatePagination(e) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...{
            page: e.page || defaultTableOptions.page
          },
          ...{
            perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
          }
        }
      }).catch(error => {
        console.error(error);
      });
    },
    fetchList() {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;
      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage
      } = this.tableOptions;
      const sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      const doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      const sortDirection = doSortDesc ? 'DESC' : 'ASC';
      const usedPage = Math.max(1, page || 1);
      const usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      NiotaClassicApiService.originatorsFetch((this.searchItem || '').trim(), usedPage, usedItemsPerPage, sortItem, sortDirection).then(res => {
        this.list = res.data.originators;
        this.serverItemsLength = res.pagination.itemCount;
      }).catch(error => {
        console.error('Error fetching originators', error);
      }).finally(() => {
        this.isFetching = false;
      });
    },
    deletePromise() {
      return NiotaClassicApiService.originatorsDelete(this.selectedItem.id);
    }
  }
};